import React, { useEffect, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";

import BIOLOGY_EXPERIMENTS from "../../../data/biologyExperiments";
import BiologyExperimentView from "../../Labs/biology/BiologyExperimentView";
import { useTranslation } from "react-i18next";

export default function BiologyLab() {
  const { t } = useTranslation();
  const { experimentId } = useParams();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const selectedClass = searchParams.get("class") || "";
  const experiments = selectedClass
    ? BIOLOGY_EXPERIMENTS[selectedClass] || []
    : [];

  const [progress, setProgress] = useState({});

  // Load saved progress
  useEffect(() => {
    const saved = JSON.parse(localStorage.getItem("biologyLabProgress")) || {};
    setProgress(saved);
  }, []);

  const updateProgress = (id) => {
    const newProgress = { ...progress, [id]: "completed" };
    setProgress(newProgress);
    localStorage.setItem("biologyLabProgress", JSON.stringify(newProgress));
  };

  // RENDER EXPERIMENT
  if (experimentId) {
    const experiment = Object.values(BIOLOGY_EXPERIMENTS)
      .flat()
      .find((e) => e.id === experimentId);

    if (!experiment)
      return <div className="p-6 text-red-500">{t("bioLab.notFound")}</div>;

    return (
      <BiologyExperimentView
        experiment={experiment}
        selectedClass={selectedClass}
        onBack={() =>
          navigate(`/dashboard/student/biology?class=${selectedClass}`)
        }
        onComplete={() => updateProgress(experimentId)}
      />
    );
  }

  // MAIN PAGE
  return (
    <div className="min-h-[calc(100vh-120px)] bg-gradient-to-br from-pink-50 to-purple-100 p-6">
      <button
        onClick={() => navigate("/dashboard/student/virtual-lab")}
        className="px-4 py-2 mb-4 bg-gray-200 rounded hover:bg-gray-300"
      >
        {t("bioLab.back")}
      </button>

      <h1 className="text-3xl font-bold text-pink-700 mb-6">
        {t("bioLab.title")}
      </h1>

      <div className="mb-8 flex gap-4 items-center">
        <label className="text-lg text-gray-700 font-medium">
          {t("bioLab.selectClassLabel")}
        </label>

        <select
          value={selectedClass}
          onChange={(e) =>
            navigate(`/dashboard/student/biology?class=${e.target.value}`)
          }
          className="px-4 py-2 rounded-xl border border-pink-300 bg-white"
        >
          <option value="">{t("bioLab.chooseClass")}</option>
          <option value="6">{t("virtualLab.class")} 6</option>
          <option value="7">{t("virtualLab.class")} 7</option>
          <option value="8">{t("virtualLab.class")} 8</option>
          <option value="9">{t("virtualLab.class")} 9</option>
          <option value="10">{t("virtualLab.class")} 10</option>
        </select>
      </div>

      {!selectedClass ? (
        <p className="text-gray-600 italic">{t("bioLab.noClass")}</p>
      ) : (
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {experiments.map((exp) => (
            <div
              key={exp.id}
              className="bg-white p-6 rounded-xl shadow-md border border-pink-200 hover:scale-[1.03] transition"
            >
              <h3 className="text-lg font-semibold text-pink-700">
                {exp.title}
              </h3>
              <p className="text-sm text-gray-600 mt-2">{exp.description}</p>

              <button
                onClick={() =>
                  navigate(
                    `/dashboard/student/biology/${exp.id}?class=${selectedClass}`
                  )
                }
                className="mt-4 bg-pink-500 text-white px-3 py-1 rounded hover:bg-pink-600"
              >
                {t("bioLab.launch")}
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
